import { Divider, useTheme } from '@material-ui/core';
import { Wrapper } from '../styled';
import { DrawerHeaderTitle } from '../../../drawer-content/components';

interface EmailHeaderProps {
  onClose?: () => void;
}

export const EmailHeader = ({ onClose }: EmailHeaderProps) => {
  const { palette } = useTheme();
  return (
    <>
      <Wrapper
        px="20px"
        height={56}
        style={{ backgroundColor: palette.common.white }}>
        <DrawerHeaderTitle title="Compose Email" handleClose={onClose} />
      </Wrapper>
      <Divider />
    </>
  );
};
